var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100",attrs:{"id":"analysis"}},[_c('b-container',{staticClass:"text-center"},[_c('h4',[_vm._v("comimg soon")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }